import { AxiosError } from "utils/infrastructure/httpClient"

export function isServerOrConnectionError(error: AxiosError) {
    return error.status === undefined || (error.status >= 500 && error.status < 600)
}
